export default "__VITE_ASSET__xTm7xOoB__"